import PropTypes from "prop-types";
import React, { useEffect, useRef, useCallback, useState } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

//i18n
import { withTranslation } from "react-i18next";

// MetisMenu
import MetisMenu from "metismenujs";
import SidebarMenuItems from "./SidebarMenuItem";
import SideBarDummyContent from "./SidebarDummyContent";

import ApplicationMenu from "./ApplicationMenu";
import { useLocation } from "react-router-dom";
import MisterIcon, { IconName } from "@rtel/mister-icons/dist/esm/components/MisterIcon";

const SidebarContentV2 = () => {
  const ref: any = useRef();
  const menuItems: menuItemsDTO[] = SideBarDummyContent();
  const [isSidebarSmall, setIsSidebarSmall] = useState<boolean>(true);
  
  const currentLocation = useLocation();


  useEffect(() => {
    ref.current.recalculate();
  }, []);


  function tToggle() {
    var body = document.body;
    setIsSidebarSmall(!isSidebarSmall);
    if (isSidebarSmall === true) {
      body.classList.add("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "sm");
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "lg");
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
      
        <ApplicationMenu 
          currentActiveApplicationLogoName="MisterCampaingManagerLogo" 
          currentActiveApplicationName="SYD" 
        />
     
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {menuItems.map((menuItem, index) => {
              const depthLevel = 0;
              return (
                <SidebarMenuItems
                  items={menuItem}
                  key={index}
                  depthLevel={depthLevel}
                  currentLocation={currentLocation}
                />
              );
            })}
          </ul>

          <button
            onClick={() => {
              tToggle();
            }}
            type="button"
            className="collapse-button"
            id="vertical-menu-btn"
          >
            <MisterIcon name="CollapseOut" size="sm" />{" "}
            <span className="collapse-toggle-text">Collapse</span>
          </button>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContentV2.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(SidebarContentV2);

export interface menuItemsDTO {
  title: string;
  path?: string;
  icon?: IconName;
  submenu?: menuItemsDTO[];
}
